import { Component, OnInit } from '@angular/core';
import { ReducerUtilityService } from 'src/app/shared/utility-services/reducer-utility.service';
import { PrintButtonComponent } from '../../print-button.component';
import { PrintButtonService } from '../../services/print-button.service';
import { NgRedux } from '@ptl/angular-redux-store';
import { StateStructure } from '@ptl/state';
import { updateActiveTab } from 'src/app/angular-elements/plan-selection/configs/reducers/plan-details-active-tab.reducer';

@Component({
    selector: 'app-plan-details-pdf-print',
    templateUrl: './../../print-button.component.html',
    styleUrls: ['./../../print-button.component.scss'],
    standalone: false
})
export class PlanDetailsPdfPrintComponent extends PrintButtonComponent implements OnInit {

  constructor(
    private reducerUtilityService: ReducerUtilityService,
    private printButtonService: PrintButtonService,
    private ngRedux: NgRedux<StateStructure>
  ) {
    super();
  }

  ngOnInit(): void {
    this.ngRedux.dispatch(updateActiveTab('DETAILS'));
    super.ngOnInit();

  }

  async onPrintPage(): Promise<void> {
      const planDetails = this.reducerUtilityService.getComponentStates().PlanDetails;
      const currentTab = this.reducerUtilityService.getComponentStates().PlanDetailsActiveTab.activeTab;
      if(currentTab === 'DETAILS'){
        const response = await this.printButtonService.fetchPlanDetailsPDF(planDetails);
        this.printButtonService.openPdfInPrintWindow(response);
      }else if(currentTab === 'PREMIUM'){
        const response = await this.printButtonService.fetchFamilyPremiumPDF(planDetails);
        this.printButtonService.openPdfInPrintWindow(response);
      }
    }
}
